<section class="pt-16 pb-8 px-container">
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Backoffice</h1>
</section>

<section class="pt-8 pb-16 mb-8 px-container">
    <div class="grid">
        <div class="card" routerLink="/backoffice/spettacoli">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="w-20 h-20"><path d="M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"/></svg>
            <h1 class="lg:text-2xl text-xl font-mono uppercase">Spettacoli</h1>
        </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 gap-y-12 mt-8">
        <div class="card" routerLink="/backoffice/area-compagnie">
            <i class="bi bi-person-badge-fill text-7xl"></i>
            <h1 class="lg:text-2xl text-xl font-mono uppercase">Area compagnie</h1>
        </div>
        <div class="card" routerLink="/backoffice/ditte-interventi">
            <i class="bi bi-tools text-7xl"></i>
            <h1 class="lg:text-2xl text-xl font-mono uppercase">Manutenzioni e verifiche</h1>
        </div>
        <div class="card" routerLink="/backoffice/calendario-interventi">
            <i class="bi bi-calendar3 text-7xl"></i>
            <h1 class="lg:text-2xl text-xl font-mono uppercase">Calendario</h1>
        </div>
    </div>    

    <ng-container *ngIf="user?.tipo == 'Amministratore'">
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-8 gap-y-12 mt-8">
            <div class="card" routerLink="/backoffice/info">
                <i class="bi bi-info-lg text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Info</h1>
            </div>
            <div class="card" routerLink="/backoffice/carnet">
                <i class="bi bi-ticket-detailed-fill text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Carnet</h1>
            </div>
            <div class="card" routerLink="/backoffice/abbecedario">
                <i class="bi bi-alphabet text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Abbecedario</h1>
            </div>
            <div class="card" routerLink="/backoffice/contatti">
                <i class="bi bi-person-lines-fill text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Contatti</h1>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-8 gap-y-12 mt-8">        
            <div class="card" routerLink="/backoffice/news">
                <i class="bi bi-newspaper text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">News</h1>
            </div>
            <div class="card" routerLink="/backoffice/stagione">
                <i class="bi bi-card-text text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Stagione</h1>
            </div>
            <div class="card" routerLink="/backoffice/home-evidenza">
                <i class="bi bi-image text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Evidenza home</h1>
            </div>
            <!-- <div class="card" routerLink="/backoffice/making-teca">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="w-20 h-20"><path d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160 64 0 0-160zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448zM224 512c17.7 0 32-14.3 32-32l0-160-64 0 0 160c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L320 0zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3l0-72.1 4.7 4.7c9 9 21.2 14.1 33.9 14.1l73.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-66.7 0-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6l0 55.7 0 .9L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 42.7L96 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-58.7c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"/></svg>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Making teca</h1>
            </div> -->
            <div class="card" routerLink="/backoffice/amministrazione-trasparente">
                <i class="bi bi-filetype-pdf text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Amministrazione trasparente</h1>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 gap-y-12 mt-8">        
            <div class="card" routerLink="/backoffice/newsletter">
                <i class="bi bi-envelope-at-fill text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Newsletter</h1>
            </div>
            <div class="card" routerLink="/backoffice/vouchers">                        
                <i class="bi bi-receipt text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Vouchers</h1>
            </div>
            <div class="card" routerLink="/backoffice/configurazioni">
                <i class="bi bi-gear-fill text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Configurazioni</h1>
            </div>
            <div class="card" routerLink="/backoffice/utenti">
                <i class="bi bi-person-fill text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Utenti</h1>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="user?.tipo == 'Operatore'">
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-8 gap-y-12 mt-8">
            <div class="card" routerLink="/backoffice/info">
                <i class="bi bi-info-lg text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Info</h1>
            </div>
            <div class="card" routerLink="/backoffice/carnet">
                <i class="bi bi-ticket-detailed-fill text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Carnet</h1>
            </div>
            <div class="card" routerLink="/backoffice/abbecedario">
                <i class="bi bi-alphabet text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Abbecedario</h1>
            </div>
            <div class="card" routerLink="/backoffice/contatti">
                <i class="bi bi-person-lines-fill text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Contatti</h1>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-8 gap-y-12 mt-8">        
            <div class="card" routerLink="/backoffice/news">
                <i class="bi bi-newspaper text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">News</h1>
            </div>
            <div class="card" routerLink="/backoffice/stagione">
                <i class="bi bi-card-text text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Stagione</h1>
            </div>
            <div class="card" routerLink="/backoffice/home-evidenza">
                <i class="bi bi-image text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Evidenza home</h1>
            </div>
            <div class="card" routerLink="/backoffice/making-teca">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="w-20 h-20"><path d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160 64 0 0-160zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448zM224 512c17.7 0 32-14.3 32-32l0-160-64 0 0 160c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L320 0zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3l0-72.1 4.7 4.7c9 9 21.2 14.1 33.9 14.1l73.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-66.7 0-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6l0 55.7 0 .9L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 42.7L96 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-58.7c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"/></svg>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Making teca</h1>
            </div>
            <div class="card" routerLink="/backoffice/amministrazione-trasparente">
                <i class="bi bi-filetype-pdf text-7xl"></i>
                <h1 class="lg:text-2xl text-xl font-mono uppercase">Amministrazione trasparente</h1>
            </div>
        </div>        
    </ng-container>
</section>